<style>
    .pay-confirm .el-card__header{
        padding: 10px;
        font-size: 12px;
        color: #48576a;
    }
</style>
<template>
    <div class="p10 pay-confirm" v-loading.body="loading">
        <div v-if="infoData.tag_type == 'bank'">
            <!-- 头部按钮部分 start -->
            <div class="el-row ly-bill-title">
                <el-col :span="6">
                    <h1 style="padding-top:5px;" v-if="infoData.info">
                        <template v-if="(infoData.info.check_status == 1 && operType == 'check') || infoData.info.check_status == 21">流水对账</template>
                        <template v-else-if="(infoData.info.check_status == 1 && operType == 'regist') || infoData.info.check_status == 22">流水登记</template>
                        <template v-else-if="(infoData.info.check_status == 1 && operType == 'remark') || infoData.info.check_status == 23">流水备注</template>
                        <template v-else>流水详情</template>
                    </h1>
                </el-col>
                <el-col :span="18" class="tr">
                    <template v-if="infoData.info && infoData.info.check_status == 1">
                        <template v-if="operType.length < 1">
                            <ly-button-time @timeUpdate="businesstimeUpdate" 
                                :infoid="infoData.info.id"
                                title='修改业务日期'
                                :type="22"
                                :date="infoData.info.business_time" 
                                v-if="buttonConfig.isUpdateBusinessTime"></ly-button-time><!-- "" -->
                            <ly-button-time @timeUpdate="timeUpdate" 
                                :infoid="infoId"
                                :type="22"
                                :date="infoData.info.trade_time" 
                                v-if="buttonConfig.isUpdateTime"></ly-button-time>
                            <el-button type="success" size="small" icon="document" 
                                @click="toggleOperType('check')" v-if="buttonConfig.isCheck">对账</el-button>
                            <el-button type="primary" size="small" icon="edit" 
                                @click="toggleOperType('regist')" v-if="buttonConfig.isRegist">登记</el-button>
                            <el-button type="info" size="small" icon="information" 
                                @click="toggleOperType('remark')" v-if="buttonConfig.isRemark">备注</el-button>
                        </template>
                        <template v-else>
                            <el-button type="primary" size="small" @click="submitEditData"
                             v-if="operType != 'check'">
                                <i class="fa fa-save"></i>&nbsp;提交
                            </el-button>
                            <el-button type="primary" size="small" @click="toggleOperType('')">
                                <i class="fa fa-remove"></i> 取消
                            </el-button>
                        </template>
                    </template>
                    <el-button type="warning" size="small" @click="backOfPay" v-else-if="buttonConfig.isBack">
                        <i class="fa fa-reply"></i> 退回
                    </el-button>
                    <ly-router-button size="small">
                        <i class="fa fa-chevron-left"></i>&nbsp;返回
                    </ly-router-button>
                </el-col>
            </div>
            <!-- 头部按钮部分 end -->
            <el-card class="box-card mt15" v-if="infoData.info">
                <el-row>
                    <el-col :span="12">
                        <el-button-group>
                            <template v-if="infoData.info.last_id && infoData.info.last_id > 0">
                                <el-button type="info"  size="small" @click="toggoleInfo(infoData.info.last_id)">
                                    <i class="fa fa-chevron-left"></i> 前一张
                                </el-button>
                            </template>
                            <template v-if="infoData.info.next_id && infoData.info.next_id > 0">
                                <el-button type="info"  size="small" @click="toggoleInfo(infoData.info.next_id)">
                                    后一张 <i class="fa fa-chevron-right"></i> 
                                </el-button>
                            </template>
                        </el-button-group>
                    </el-col>
                    <el-col :span="12" class="tr">
                        <template v-if="infoData.info.check_status">
                            <ly-tag tag-category="payconfirm" :tag-status="infoData.info.check_status"></ly-tag>
                        </template>
                        <template v-if="infoData.info.is_jindie == 1">
                            <el-tag type="warning">已发送金蝶</el-tag>
                        </template>
                    </el-col>
                </el-row>
                <!-- 单据信息 start -->
                <ly-information 
                    :config="infoConfig"
                    :data="infoData.info"
                    class="mt15">        
                </ly-information>
                <!-- 单据信息 end -->
            </el-card>
            <template v-if="infoData.info">
                <!-- 对账客户列表（第28批插入需求 2018-03-14加入） start -->
                <template v-if="(infoData.info.check_status == 1 && operType == 'check')">
                    <ly-confirm-customer 
                        :account-id="infoData.info.account_id"
                        :amount="infoData.info.amount"
                        @change="submitEditData"
                        ref="check">
                    </ly-confirm-customer>
                </template>
                <!-- 对账客户列表（第28批插入需求 2018-03-14加入）  end  -->

                <!-- 对账页面 start -->
                <template v-if="infoData.info.check_status == 21">
                    <ly-confirm-trade 
                        :status="infoData.info.check_status"
                        :data="infoData.checking"
                        :number="infoData.info.account_number"
                        :amount="infoData.info.amount"
                        ref="check">
                    </ly-confirm-trade>
                </template>
                <!-- 对账页面  end  -->

                <!-- 流水登记 start -->
                <template v-if="(infoData.info.check_status == 1 && operType == 'regist')|| infoData.info.check_status == 22">
                    <ly-confirm-checkin 
                        :status="infoData.info.check_status"
                        :data="infoData.register"
                        ref="regist">
                    </ly-confirm-checkin>
                </template>
                <!-- 流水登记  end  -->
                
                <!-- 流水备注 start -->
                <template v-if="(infoData.info.check_status == 1 && operType == 'remark')|| infoData.info.check_status == 23">
                    <ly-confirm-remark 
                        :status="infoData.info.check_status"
                        :data="infoData.remark" 
                        ref="remark">
                    </ly-confirm-remark>
                </template>
                <!-- 流水备注  end  -->
            </template>
             <!-- 处理记录 start -->
            <el-card class="box-card mt15">
                <template slot='header'>
                <div>
                    <span>处理记录</span>
                </div>
                </template>
                <p class="f12 mt10 ctext" v-for="el in infoData.history">
                    {{el}}
                 </p>
            </el-card>
            <!-- 处理记录 end -->
        </div>
        <ly-cashback-info v-else-if="infoData.tag_type == 'cash'" :info="infoData"></ly-cashback-info>
    </div>
</template>
<script>
    import {mapGetters} from 'vuex'
    import InfoConfig from './info-config'
    import LyInformation from '@c/information'
    import LyTable from '@c/table'
    import LyTag from '@c/tag'
    import LyRouterButton from '@c/router-button'
    import LyBnttonInvalid from '@c/button-invalid'
    import LyButtonTime from '@c/button-time'

    import LyConfirmCustomer from './customer.vue'
    import LyConfirmTrade from './trade.vue'
    import LyConfirmCheckin from './checkin.vue'
    import LyConfirmRemark from './remark.vue'
    // 现金回款流水详情，2018-05-21 往来账插入需求
    import LyCashbackInfo from '../cashback/info.vue'

    export default {
        mixins: [
            InfoConfig
        ],
        components: {
            LyTable,
            LyTag,
            LyInformation,
            LyRouterButton,
            LyBnttonInvalid,
            LyConfirmCustomer,
            LyConfirmTrade,
            LyConfirmCheckin,
            LyConfirmRemark,
            LyCashbackInfo,
            LyButtonTime
        },
        data () {
            return {
                infoId: '0',
                loading: true,
                infoData: {}, // 详情的数据，包含货品数据、处理记录
                operType: '', // 操作的类型 [check:对账, regist:登记, remark:备注]
                buttonConfig: {} // 按钮的配置
            }
        },
        computed: {
            ...mapGetters([
                'userInfo'     
            ]),
            ...mapGetters('route', [
                'currRoute'
            ])
        },
        watch: {
            '$route' (to, from) {
                // 路由变化时，更新配置
                if (to.name === 'PaymentConfirmInfo') {
                    this.queryInfoData()
                }
            }
        },
        mounted () {
            this.queryInfoData()
        },
        methods: {
            // 切换操作类型
            toggleOperType (type) {
                this.operType = type
            },
            /**
             * 详情页面的切换
             */
            toggoleInfo (id) {
                // 跳转到的路由
                let path = '/bill/' + this.currRoute.path + '/info/' + id
                this.routerJump(path)
            },
            /**
             * 路由跳转处理
             * @param  {[type]} path [description]
             * @return {[type]}      [description]
             */
            routerJump (path) {
                path = path.replace('#', '')
                this.loading = true
                this.$router.push(path)
            },
            /**
            /**
             * 获取详情的数据
             */
            queryInfoData (callback) {
                // 初始化读取配置的
                this.readRouteConfig()
                // 获取详情的ID
                this.infoId = this.$route.params.id
                this.$api.query(this.currRoute.api ,{
                    route: this.currRoute.path
                }, [this.infoId]).then((rs) => {
                    this.loading = false
                    this.infoData = rs
                    if (typeof callback === 'function') {
                        callback()
                    }
                }).catch((error) => {
                    this.loading = false
                    this.$message({
                        message: error,
                        type: 'warning'
                    })
                })
            },
            /**
             * 数据的重新请求
             * @return {[type]} [description]
             */
            refInfoData (callback) {
                this.loading = true
                this.toggleOperType('')
                this.queryInfoData(callback)
            },
            /**
             * 提交修改后的数据
             * @return {[type]} [description]
             */
            submitEditData () {
                let el = this.$refs[this.operType]
                let confirmTxt = '对账'
                if (this.operType === 'regist') {
                    confirmTxt = '登记'
                } else if (this.operType === 'remark') {
                    confirmTxt = '备注'
                }
                if (el.validate()) {
                    let data = {
                        id: this.infoId,
                        oper_type: this.operType
                    }
                    data = Object.assign(data, el.getData())
                    // 收支金额与实收/实退金额不一致时，提示不一样  2021-3-12 by welpher.yu
                    let msg = '确定提交该流水' + confirmTxt + '?'
                    if (this.operType === 'regist') {
                        let huikuan = data.register.map(line => line.huikuan_amount).reduce((acc,curr) => {
                            return parseFloat(acc) + parseFloat(curr)
                        })
                        if (huikuan.toFixed(2) !== parseFloat(this.infoData.info.amount || 0).toFixed(2)) {
                            msg = '收支金额与实收/实退金额不一致确认是否继续提交？'
                        }
                    }
                    this.$confirm(msg, '提示', {
                          confirmButtonText: '确定',
                          cancelButtonText: '取消',
                          type: 'warning',
                          dangerouslyUseHTMLString:true
                    }).then(() => {
                        // 如果是登记自动备注
                        if (this.operType === 'regist' && this.userInfo.is_zdcomment === 1) {
                            this.splicCheckinZhaiyao(data.register)
                        }
                        this.$api.create(this.currRoute.api + '/' + this.infoId + '/review', data).then(() => {
                            // 清空状态重新请求数据
                            this.refInfoData()
                        }).catch((error) => {
                            this.$message({
                                message: error,
                                type: 'warning'
                            })
                        })
                    }).catch(() => {})
                }
            },
            /**
             * 第34批需求，自动生成客户备注
             * 生成规则：
             * 对账时候自动生成备注“流水日期（年月日）+收款账户名+（对方信息）”--填充到登记单每个客户备注行。并传输金蝶。
             * 如果填写了有备注，加在自动生成的后面，这个在原型上没有是元芳说的
             */
            splicCheckinZhaiyao (customerList) {
                let remark = this.infoData.info.trade_time + 
                            ' ' + 
                            this.infoData.info.account_name + 
                            ' ' + 
                            this.infoData.info.duifangxinxi
                // 拼接每个客户的备注信息
                customerList.forEach((el) => {
                    el.zhaiyao = remark + ' ' + el.zhaiyao
                })
            },
            /**
             * 回退流水处理
             */
            backOfPay () {
                this.$confirm('确定已删除金蝶单据并退回该流水处理？', '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning'
                }).then(() => {
                    this.$api.delete(this.currRoute.api + '/' + this.infoId + '/review/' + this.infoId).then((data) => {
                        this.$message({
                            message: '已退回',
                            type: 'success'
                        })
                        this.refInfoData(() => {
                            this.$nextTick(() => {
                                this.toggleOperType('regist')
                                this.infoData.register = data.register
                            })
                        })
                    }).catch((error) => {
                        this.$message({
                            message: error,
                            type: 'warning'
                        })
                    })
                }).catch(() => {})
            },
            /**
             * 读取当前页面的路有配置
             */
            readRouteConfig () {
                // 获得当前页面的配置
                // let routeConfig = this.$utils.readRouteConfig(this.$route.fullPath)
                 let routeConfig = this.$utils.readPageConfig(this.currRoute, 'info')
                // 获得tab的配置
                if (routeConfig && routeConfig.config) { 
                    this.buttonConfig = routeConfig.config.button ? JSON.parse(routeConfig.config.button || '') : {}
                }
            },
            /**
             * 日期修改之后的事件监听
             */
            timeUpdate () {
                // 详情数据刷新
                this.refInfoData()
            },
            /*
            * 业务日期修改之后的事件监听
            */
            businesstimeUpdate () {
                // 详情数据刷新
                this.refInfoData()
            }
        }
    }
</script>